export enum AdminRole {
  ADMIN = "admin",
  SUPER_ADMIN = "super-admin",
}
